import React from "react";
import less from "./crewInfo.module.scss";
import moment from "moment";

const CrewInformation = props => {
  const { booking } = props;
  const { trip } = booking || {};
  const { busDriver, busHost, secondaryBusHost } = trip || {};

  if (!busHost || !busDriver) {
    return null;
  }

  const monthsOfExperience = busHost?.createdOn
    ? moment().diff(moment(parseInt(busHost.createdOn)), "months")
    : 0;

  const busHostLanguage = (() => {
    const arr = busHost?.languagesSpoken
      ?.sort((a, b) => a.order - b.order)
      .slice(0, 3)
      .map(item => item.language);

    if (!arr?.length) return "";

    return arr.length > 1
      ? `${arr.slice(0, -1).join(", ")} & ${arr.at(-1)}`
      : arr[0];
  })();

  const secondaryMonthsOfExperience = secondaryBusHost?.createdOn
    ? moment().diff(moment(parseInt(secondaryBusHost.createdOn)), "months")
    : 0;

  const secondaryBusHostLanguage = (() => {
    const arr = secondaryBusHost?.languagesSpoken
      ?.sort((a, b) => a.order - b.order)
      .slice(0, 3)
      .map(item => item.language);

    if (!arr?.length) return "";

    return arr.length > 1
      ? `${arr.slice(0, -1).join(", ")} & ${arr.at(-1)}`
      : arr[0];
  })();

  const calculateMonths = date => {
    if (!date) return "";
    if (date < 12) return `${date} Months`;
    const totalYears = parseFloat((date / 12).toFixed(1));
    return `${totalYears} Years`;
  };

  return (
    <div className={less.wrapper}>
      <p>Your Crew</p>
      <div className={less.crewInfo}>
        <div className={less.busDriver}>
          <div className={less.header}>
            <span>Bus Driver</span>
          </div>
          <div className={less.crewInfoDetails}>
            <div className={less.profilePicture}>
              {busDriver.profilePhotoUrl ? (
                <img src={busDriver.profilePhotoUrl} alt="profile" />
              ) : (
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/user.svg"
                  alt="profile"
                />
              )}
            </div>
            <div className={less.details}>
              <div className={less.nameWrapper}>
                <div className={less.name}>
                  <span>{busDriver.name}</span>
                  {busDriver.hasSafetyBadge ? (
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/verified.svg"
                      alt="verified"
                    />
                  ) : null}
                </div>
              </div>
              {busDriver?.kyc?.dlValidTill ? (
                <span className={less.validity}>
                  License valid until{" "}
                  {moment(parseInt(busDriver.kyc.dlValidTill)).format(
                    "Do MMMM, YYYY"
                  )}
                </span>
              ) : null}
            </div>
          </div>
        </div>
        <div className={less.busHost}>
          <div className={less.header}>
            <span>Marshal</span>
          </div>
          <div className={less.border}>
            <div className={less.primaryCrew}>
              <div className={less.primaryCrewInfo}>
                <div className={less.profilePicture}>
                  {busHost.profilePhotoUrl ? (
                    <img src={busHost.profilePhotoUrl} alt="profile" />
                  ) : (
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/user.svg"
                      alt="profile"
                    />
                  )}
                  {Number(busHost?.crewScore) >= 3.8 && (
                    <div className={less.rating}>
                      <span>
                        {Number(busHost.crewScore)
                          .toFixed(1)
                          .replace(/\.00$/, "")}
                      </span>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/star.svg"
                        alt="star"
                      />
                    </div>
                  )}
                </div>
                <div className={less.details}>
                  <div className={less.nameWrapper}>
                    <div className={less.name}>
                      <span>{busHost.name}</span>
                      {busHost.hasSafetyBadge ? (
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/verified.svg"
                          alt="verified"
                        />
                      ) : null}
                    </div>
                    {monthsOfExperience >= 2 ? (
                      <div className={less.experience}>
                        <span>
                          {calculateMonths(monthsOfExperience)} Experience
                        </span>
                      </div>
                    ) : busHost.createdOn != null && monthsOfExperience < 2 ? (
                      <div className={less.newHired}>
                        <span>Newly Hired</span>
                      </div>
                    ) : null}
                  </div>
                  {busHost.marshalLastTrainedDate ? (
                    <div className={less.info}>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/trained.svg"
                        alt="trained"
                      />
                      <span className={less.validity}>
                        Last trained on{" "}
                        {moment(
                          parseInt(busHost.marshalLastTrainedDate)
                        ).format("Do MMMM, YYYY")}
                      </span>
                    </div>
                  ) : busHost?.createdOn ? (
                    <div className={less.info}>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/trained.svg"
                        alt="trained"
                      />
                      <span className={less.validity}>
                        Last trained on{" "}
                        {moment(parseInt(busHost.createdOn)).format(
                          "Do MMMM, YYYY"
                        )}
                      </span>
                    </div>
                  ) : null}

                  {busHostLanguage ? (
                    <div className={less.info}>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/language.svg"
                        alt="language"
                      />
                      <span className={less.validity}>
                        Speaks {busHostLanguage}
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            {secondaryBusHost ? (
              <div className={less.primaryCrew}>
                <div className={less.primaryCrewInfo}>
                  <div className={less.profilePicture}>
                    {secondaryBusHost.profilePhotoUrl ? (
                      <img
                        src={secondaryBusHost.profilePhotoUrl}
                        alt="profile"
                      />
                    ) : (
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/user.svg"
                        alt="profile"
                      />
                    )}
                    {Number(secondaryBusHost?.crewScore) >= 3.8 && (
                      <div className={less.rating}>
                        <span>
                          {Number(secondaryBusHost.crewScore)
                            .toFixed(1)
                            .replace(/\.00$/, "")}
                        </span>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/star.svg"
                          alt="star"
                        />
                      </div>
                    )}
                  </div>
                  <div className={less.details}>
                    <div className={less.nameWrapper}>
                      <div className={less.name}>
                        <span>{secondaryBusHost.name}</span>
                        {secondaryBusHost.hasSafetyBadge ? (
                          <img
                            src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/verified.svg"
                            alt="verified"
                          />
                        ) : null}
                      </div>
                      {secondaryMonthsOfExperience >= 2 ? (
                        <div className={less.experience}>
                          <span>
                            {calculateMonths(secondaryMonthsOfExperience)}{" "}
                            Experience
                          </span>
                        </div>
                      ) : secondaryBusHost?.marshalOnboardingDateience !=
                          null && secondaryMonthsOfExperience < 2 ? (
                        <div className={less.newHired}>
                          <span>Newly Hired</span>
                        </div>
                      ) : null}
                    </div>
                    {secondaryBusHost.marshalLastTrainedDate ? (
                      <div className={less.info}>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/trained.svg"
                          alt="trained"
                        />
                        <span className={less.validity}>
                          Last trained on{" "}
                          {moment(
                            parseInt(secondaryBusHost.marshalLastTrainedDate)
                          ).format("Do MMMM, YYYY")}
                        </span>
                      </div>
                    ) : secondaryBusHost?.createdOn ? (
                      <div className={less.info}>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/trained.svg"
                          alt="trained"
                        />
                        <span className={less.validity}>
                          Last trained on{" "}
                          {moment(parseInt(secondaryBusHost.createdOn)).format(
                            "Do MMMM, YYYY"
                          )}
                        </span>
                      </div>
                    ) : null}

                    {secondaryBusHostLanguage ? (
                      <div className={less.info}>
                        <img
                          src="https://d1flzashw70bti.cloudfront.net/original/images/tracer/selfHelp/language.svg"
                          alt="language"
                        />

                        <span className={less.validity}>
                          Speaks {secondaryBusHostLanguage}
                        </span>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrewInformation;
